import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import quoteIconDesktop from '../../images/Icons/quote.svg';
import quoteIconMobile from '../../images/Icons/quoteTransparent.svg';
import {
  StyledQuoteBlock,
  StyledQuoteBodyContainer,
  StyledQuoteAuthorContainer,
  StyledQuoteImage,
  StyledQuoteName,
  StyledQuoteTitle,
  QuoteIconWrapperDesktop,
  QuoteIconWrapperMobile,
} from './styles.js';

export const QuoteBlock = ({
  name,
  title,
  image,
  body,
  backgroundColor = 'hero.lilac',
}) => {
  return (
    <StyledQuoteBlock $backgroundColor={backgroundColor}>
      <QuoteIconWrapperMobile>
        <ResponsiveImage
          src={quoteIconMobile}
          alt={'quote icon'}
          height={175}
          width={175}
        />
      </QuoteIconWrapperMobile>
      <div>
        <QuoteIconWrapperDesktop>
          <ResponsiveImage
            src={quoteIconDesktop}
            alt={'quote icon'}
            height={40}
            width={40}
          />
        </QuoteIconWrapperDesktop>
        <StyledQuoteBodyContainer>{body}</StyledQuoteBodyContainer>
      </div>
      <StyledQuoteAuthorContainer>
        {image && (
          <StyledQuoteImage>
            <ResponsiveImage
              src={image.src}
              alt={image.alt}
              width={48}
              height={48}
            />
          </StyledQuoteImage>
        )}
        <div>
          <StyledQuoteName>{name}</StyledQuoteName>
          {title && <StyledQuoteTitle>{title}</StyledQuoteTitle>}
        </div>
      </StyledQuoteAuthorContainer>
    </StyledQuoteBlock>
  );
};

QuoteBlock.displayName = 'Quote';

QuoteBlock.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  body: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};
